import { Component, OnInit, ViewContainerRef, Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { PayrollRevisionService } from '../Services/PayrollRevisionService';

@Component({
  selector: 'Payroll_Revision',
  templateUrl: '../Payroll_Revision_Data/PayrollRevisionData.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [PayrollRevisionService]
})

export class PayrollRevisionDatacomponent implements OnInit {
  PayrollCheckedData = new PayrollCheckedData();
  innerWidth: number;
  TenantID: string;
  loading: boolean = false;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  PayrollRevisonData: Array<any>;
  constructor(
    public _PayrollRevision: PayrollRevisionService,
    private router: Router,
    private Activeroute: ActivatedRoute,
    public toastr: ToastsManager,
    vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
  }
  ngOnInit() {
    if (this.Activeroute.snapshot.params['TenantID'] != null) {
      this.TenantID = JSON.parse(atob(this.Activeroute.snapshot.params['TenantID']));
      this.Get_CurrentUserDataLog();
      localStorage.setItem('TenantID', this.TenantID);
      this.ChangeHeadeFooterColor();
    }
  }

  public Get_CurrentUserDataLog() {
    this.loading = true;
    this._PayrollRevision.Get_CurrentUserDataLog(this.TenantID).subscribe(res => {
      this.PayrollRevisonData = res;
      this.loading = false;
    });
  }

  public singleselect() {
    this.PayrollCheckedData.PayrollData = this.PayrollRevisonData.filter(x => x.Checked == true);
    console.log(this.PayrollCheckedData);
  }

  public SendMail() {
    if (this.PayrollCheckedData.PayrollData.length != 0) {
      this.loading = true;
      this.PayrollCheckedData.TenantID = this.TenantID;
      this._PayrollRevision.SendMailPayrollRevision(this.PayrollCheckedData).subscribe(res => {
        
        var data = res;
        if (data.message == "Payroll revision mail sent successfully.") {
          this.toastr.success(data.message);
          this.PayrollRevisonData.forEach(x => { x.Checked = false });
          this.loading = false;
        }
        else {
          this.toastr.error(data.message);
          this.loading = false;
        }
      })
    }
    else {
      this.toastr.error('Please Select EHID.');
    }
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }
  public ExportAllData() {
    this.loading = true;
    this.PayrollCheckedData.TenantID = this.TenantID;
    this._PayrollRevision.ExportAllData(this.PayrollCheckedData).subscribe(res => {
      let data = res;
      if (data.message == "Payroll revision mail sent successfully.") {
        this.toastr.success(data.message);
        this.loading = false;
      }
      else {
        this.toastr.error(data.message);
        this.loading = false;
      }
    })
  }

  public Cancelpayroll() {
    this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(this.TenantID)), pageName: btoa(JSON.stringify('Payroll-Revision')) }]);
  }
}
export class PayrollCheckedData {
  TenantID: string;
  PayrollData: any = [];
}



// WEBPACK FOOTER //
// ./src/app/Payroll_Revision_Data/PayrollRevisionData.component.ts